<template>
  <card-item 
    card="item_discipline" 
    :tabs="tabs" 
    :activeTab="activeTab" 
    :id="id" 
    :infoKeys="infoKeys"/>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          key:'information_card',
          title: "Информация", 
          component: () => import("./Info"),
        },
        {
          key:'classes_card',
          title: "Классы", 
          component: () => import("./Classes"),
        },
      ],
      activeTab: 0,
      infoKeys:[
        {
          key: 'title',
          title:'Предмет'
        },
      ]
    };
  },
};
</script>